import styled, {css, keyframes} from 'styled-components';

import {Icon} from 'components/ui-kit/Icon';
import {colors, border, breakpoint} from 'theme';

const commonBlock = css`
    display: flex;
    flex-flow: column nowrap;
    padding: 20px;
    background-color: ${colors.white};
    border-radius: ${border.radius};
`;

const fullWidth = css`
    grid-column: 1 / -1;
`;

export const ContentWrapper = styled.div`
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr;
    margin-bottom: 10px;

    @media (min-width: 1366px) {
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
    }
`;

export const DatesContainer = styled.div`
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: ${border.radius};
    ${fullWidth};

    @media (min-width: ${breakpoint.tablet}) {
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: flex-start;
    }
`;

export const PackageTypeContainer = styled.div`
    ${fullWidth};
    width: 30%;
`;

export const Map = styled.div`
    display: flex;
    flex-flow: column wrap;
    ${fullWidth}
    ${commonBlock}

    img {
        width: 60%;
        padding-top: 15px;
        margin: 0 auto;
        -webkit-user-drag: none;
    }
`;

export const CheckCode = styled.div`
    display: flex;
    flex-flow: column wrap;
    ${fullWidth};
    ${commonBlock};

    @media (min-width: ${breakpoint.tablet}) {
        flex-flow: row nowrap;
        align-items: baseline;
        padding: 0 20px 12px;
    }
`;

export const ChartBox = styled.div`
    ${commonBlock}
`;

export const SearchBox = styled.div`
    display: flex;
    flex-flow: column wrap;
    ${fullWidth}
    ${commonBlock}
`;

export const BlockTitle = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
`;

export const BlockTitleDescription = styled.div`
    color: ${colors.textSecondary};
    font-size: 12px;
    margin-top: 12px;
    margin-bottom: 15px;
`;

export const BlockSettingsIcon = styled(Icon)`
    display: none;

    @media (min-width: ${breakpoint.tablet}) {
        display: block;
        align-self: center;
    }
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 280px;

    animation: ${opacity} 2s ease;
`;
